import { atom } from 'recoil';

const redirectInfo = atom({
  key: 'redirectInfo',
  default: {
    path: '',
  },
});

export { redirectInfo };
